import { render, staticRenderFns } from "./DesignAuthen.vue?vue&type=template&id=40ca0d36&"
import script from "./DesignAuthen.vue?vue&type=script&lang=js&"
export * from "./DesignAuthen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports